<template>
    <div class="success-page" id="success-page">
        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :background="'transparent'"
            @clickMenu="change_menu(context, true)"
        />

        <div class="success-page__container">

            <div class="success-page__title">
                Оплата прошла успешно
            </div>

            <div class="success-page__descr">
                Ваш заказ №{{order}} принят. Ожидайте смс со статусом заказа.
            </div>

            <div class="success-page__button-main"
                 @click="$router.push(`/check-order?order=${order}`)"
            >
              Посмотреть статус заказа
            </div>

            <div
                class="success-page__button-main"
                style="margin-top: 8px; background-color: transparent; border: 1px solid #ffffff; color: #ffffff;"
                @click="$router.push('/')"
            >
              Вернуться на главную
            </div>

        </div>


        <transition 
            name="fade-menu" 
            appear
            mode="out-in"
        >
            <app-menu 
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="change_menu(context, false)"
                @clickOutside="change_menu(context, false)"
            />
        </transition >
        
        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-overlay 
                v-if="overlay"
            />
        </transition>

      <transition
          name="fade-overlay"
          appear
          mode="out-in"
      >

        <app-alert
            v-if="error.status"
            buttonText="ОК"
            :text="error.text"
            @clickGrowButtonPopup="() => {
              error.status = false
              overlay = false
              loading = false
            }"
        />

      </transition>
    </div>
</template>

<script>

    const AppHeader = () => import('@/components/header.vue')
    const AppMenu = () => import('@/components/menu.vue')
    const AppOverlay = () => import('@/components/overlay.vue')
    const AppAlert = () => import('@/components/popups/error')

    import change_menu from "@/views/theme/modules/change_menu";

    export default {
      async mounted() {
        await this.$store.dispatch('auth/setIsCreatedOrder', {
          status: false
        })
      },
      data() {
            return {
               context: this,
               overlay: false,
               menu: false,
               text: '',
               loading: false,
               error: {
                 status: false,
                 text: ''
               }
            }
        },
        computed: {
          order() {
            return this.$store.getters['auth/order']
          }
        },
        components: {
          AppHeader,
          AppMenu,
          AppOverlay,
          AppAlert
       },
        methods: {
          change_menu
       }
    }
</script>

<style lang="less">
    .success-page {
        background-color: #2F1F4C;
        width: 100%;
        height: calc(var(--vh, 1vh) * 100);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: #FFFFFF;
        text-align: center;
        min-height: 300px;
    }

    #success-page .header-component__arrow {
        display: none;
    }

    #success-page .header-component {
        justify-content: flex-end;
    }

    .success-page__container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding-left: 16px;
        padding-right: 16px;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

    .success-page__title {
        font-size: 22px;
        font-family: 'Montserrat-Bold';
    }

    @import '~/assets/fonts/roboto/Roboto-Light.less';

    .success-page__descr {
        font-size: 15px;
        font-family: 'Roboto-Light';
        margin-top: 24px;
        width: 100%;
        max-width: 440px;
        opacity: .9;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .success-page__button-main {
      height: 44px;
      width: 343px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 16px;
      color: #31283D;
      background-color: #FFFFFF;
      margin-top: 24px;
      border-radius: 5px;
      font-family: 'Montserrat-Medium';
    }

    .success-page__check-order {
      font-family: 'Roboto-Light';
      font-size: 15px;
      color: #FFFFFF;
      margin-top: 28px;
      border-bottom: 1px dashed #FFFFFF;
      cursor: pointer;
      text-decoration: none;
    }


    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .success-page__button {
        width: 343px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        background: #FFFFFF;
        height: 44px;
        color: #31283D;
        text-align: center;
        font-size: 16px;
        font-family: 'Montserrat-Medium';
        cursor: pointer;
    }
</style>